<template>
  <div id="contenedor-default-pagos">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4">
        <v-card-text>
          <titulo-tool-bar
            titulo="Solicitudes de pago">
            <template
              v-slot:opciones-derecha>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :filtros="filtros"
            @nuevaSolicitud="mostrarRegistrarSolicitud = true">
          </tool-bar>
        </v-card-text>
      </v-card>
      <!-- Contenido -->
      <v-card
        flat>
        <v-card-text>
          <listado
            :listado="getPagosSolicitudes"
            :filtros="filtros">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarRegistrarSolicitud"
      scrollable
      persistent
      width="65%">
      <v-card>
        <v-card-title class="secondary--text">
          Nueva solicitud
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.nuevaSolicitudPago.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <nueva-solicitud
            ref="nuevaSolicitudPago"
            @formularioValido="setFormularioValido"
            @enviandoFormulario="setEnviandoFormulario"
            @cerrar="cerrarRegistrarSolicitud">
          </nueva-solicitud>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3"
            @click="$refs.nuevaSolicitudPago.cerrar()">
          </custom-button>
          <custom-button
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.nuevaSolicitudPago.guardar()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="estaSolicitudPago"
      v-model="mostrarBorrarSolicitudPago"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-solicitud-pago
        :solicitudPagoEliminar="estaSolicitudPago"
        :tipo="tipoSolicitudPago"
        v-on:cerrar="cerrarEliminarSolicitudPago">
      </eliminar-solicitud-pago>
    </v-dialog>
  </div>
</template>

<script>
import PAGOS_SOLICITUDES from '@/graphql/querys/administracion/pagos/pagosSolicitudes.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import CustomButton from '@/components/buttons/Button.vue';
import ToolBar from './ToolBar.vue';
import NuevaSolicitud from '@/components/administracion/pagos/solicitudes/Nueva.vue';
import EliminarSolicitudPago from '@/components/administracion/pagos/solicitudes/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'DefaultPagos',
  components: {
    TituloToolBar,
    ToolBar,
    CustomButton,
    NuevaSolicitud,
    EliminarSolicitudPago,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarSolicitud: false,
      mostrarBorrarSolicitudPago: false,
      estaSolicitudPago: null,
      tipoSolicitudPago: null,
      formularioValido: false,
      enviandoFormulario: false,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
      },
    };
  },
  apollo: {
    pagosSolicitudes: {
      query: PAGOS_SOLICITUDES,
    },
  },
  methods: {
    cerrarEliminarSolicitudPago() {
      this.mostrarBorrarSolicitudPago = false;
      this.estaSolicitudPago = null;
      this.tipoSolicitudPago = null;
    },
    cerrarRegistrarSolicitud() {
      this.mostrarRegistrarSolicitud = false;
    },
    setFormularioValido(valor) {
      this.formularioValido = valor;
    },
    setEnviandoFormulario(valor) {
      this.enviandoFormulario = valor;
    },
  },
  computed: {
    getPagosSolicitudes() {
      if (!this.pagosSolicitudes) return [];
      return this.pagosSolicitudes;
    },
  },
  mounted() {
    eventBus.$on('borrar-solicitud-pago', (solicitudPago) => {
      this.tipoSolicitudPago = 'solicitud';
      this.estaSolicitudPago = solicitudPago;
      this.mostrarBorrarSolicitudPago = true;
    });
    eventBus.$on('borrar-solicitud-pago-detalle', (solicitudPagoDetalle) => {
      this.tipoSolicitudPago = 'detalle de solicitud';
      this.estaSolicitudPago = solicitudPagoDetalle;
      this.mostrarBorrarSolicitudPago = true;
    });
  },
};
</script>

<style lang="scss">

</style>
